/* eslint-disable max-len */
import {
  getCustomerPriceGroup,
  getCustomerForId,
  getUserId,
  getUserById,
  getTotalPrice,
} from "../../../selectors";
import { getProductListForPricesEansCurrencyAndOrder } from "./getProductListForPricesEansCurrencyAndOrder";
import { calculateTotals } from "./calculateTotals";
import { formatDate } from "./formatDate";

export const buildOrderPDF = (context, order) => {
  const customer = getCustomerForId(context, order.customerId);
  const customerPriceGroup = getCustomerPriceGroup(context, customer) || "";
  const currency = customerPriceGroup.startsWith("CH") ? "CHF" : "EUR";
  const deliveryAddress = order.deliveryAddress || {};
  const orderType = order.orderType ? order.orderType.value : "";
  const products = getProductListForPricesEansCurrencyAndOrder(
    context,
    currency,
    order,
  );
  const totals = calculateTotals(
    order,
    products,
    getTotalPrice(context, { doc: order }),
  );
  const userId = getUserId(context);
  const user = getUserById(context, userId);
  return {
    orderId: order.id,
    createDate: formatDate(new Date()),
    draft: order.status !== "done",
    currency,
    contact: {
      name: user.Name,
      phone: user.Phone,
      email: user.Email,
    },
    customerService: {
      name: customer.SalespersonName__c,
      phone: customer.SalespersonPhone__c,
      email: customer.SalespersonEmail__c,
    },
    customer: {
      title: customer.Name,
      office: customer.Name2__c,
      street: customer.BillingStreet,
      postalcode: customer.BillingPostalCode,
      city: customer.BillingCity,
      country: customer.BillingCountry,
    },
    deliveryAddress: {
      name: deliveryAddress.name,
      name2: deliveryAddress.name2,
      street: deliveryAddress.street,
      postalcode: deliveryAddress.postalCode,
      city: deliveryAddress.city,
      country: deliveryAddress.country,
    },
    summary: {
      orderNumber: order.orderNumber,
      minDeliveryDate: formatDate(order.minDeliveryDate),
      vatId: customer.VATID__c,
      orderType,
      season: order.season,
      orderDate: formatDate(order.orderDate),
      association: customer.AssociationCode__c,
      associationId: customer.AssociationMemberNo__c,
      sellerNumber: customer.CustomerNo__c,
      invoiceNumber: customer.BillToCustomerNo__c,
    },
    paymentTerms: customer.PaymentTerms__c,
    deliveryTerms: customer.ShipmentMethodDescription__c,
    germanInfo:
      "Vertragsparteien erheben die Allgemeinen Geschäftsbedingungen (AGB) der Schöffel Sportbekleidung GmbH. Der Käufer bestätigt, dass er auf den AGB-Bestand und den AGB-Inhalt hingewiesen wurde und dass der AGB-Text durch selbstlesen zur Kenntnis genommen wurde.",
    swissInfo:
      "Die Vertragsparteien erheben die Allgemeinen Geschäftsbedingungen (AGB) der Schöffel Schweiz AG zum integrierenden Bestandteil dieses Vertrages. Der Käufer bestätigt, dass er auf den AGB-Bestand und den AGB-Inhalt hingewiesen wurde und, dass er den AGB-Text durch Selbstlesen zur Kenntnis genommen hat.",
    products,
    totals,
    notes: order.notes,
  };
};
